import api from '@/request/api';
import { UserFunc } from '../../utils/constants';
export default {
	namespaced: true,
	state: {
		// 是否已登录
		hasLogged: false,
		// 是试玩账号--- yes 传1 . no 传0
		isTestAccount: false,
		//iphonex
		iphonex: false,
		ios: false,
		// 用户信息
		userInfo: {},
		scroll_domain_h5: [], //滚动域名
		// 用户绑定
		userBinding: {},
		// 用户权益总收益
		equityIncome: {},
		//余额
		userBalance: {},
		//安全中心初始化用户数据
		initUserData: {},
		//个人中心功能
		UserFunc,
		noviceTaskStatus: 0, //新手任务/0-未请求状态或新手任务被关闭,1-未完成,2-已完成
		announceRecommendGm: {}, //推荐游戏列表缓存
	},
	mutations: {
		upDataUserInfo(state, params) {
			//更新用户信息
			// params : {
			// 	istester:'',
			// 	user: {},
			// }
			state.hasLogged = params.user.user ? true : false;
			if (params.istester) {
				if (params.istester === '1') {
					state.isTestAccount = true;
				} else {
					state.isTestAccount = false;
				}
			}
			state.userInfo = params.user;
			state.scroll_domain_h5 = params.user.scroll_domain_h5;
		},
		clearUserInfo(state) {
			state.hasLogged = false;
			state.isTestAccount = false;
			state.userInfo = {};
			state.userBalance = {};
			state.initUserData = {};
			state.noviceTaskStatus = 0;
		},
		upDatanoviceTaskStatus(state, newValue) {
			//更新新手任务
			state.noviceTaskStatus = newValue;
		},
		upDataUserBinding(state, newValue) {
			state.userBinding = newValue;
		},
		upDataUserBalance(state, params) {
			state.userBalance = params;
		},
		setInitUserData(state, params) {
			state.initUserData = params;
		},
		setDevice(state, params) {
			state.iphonex = params.iphonex;
			state.ios = params.ios;
		},
		announceRecommendGm(state, params) {
			state.announceRecommendGm = params;
		},
	},
	actions: {
		requesyNewPeo({ commit }) {
			//请求新手任务-完成状态
			// context.commit('increment')
			api.activity
				.getnewgiftStatus({
					activityid: 20,
					platform: 'getactid20status',
				})
				.then(res => {
					if (res.status == '1181000030') {
						let arr1 = res.data.data;
						if (arr1.isdeposit == 1 && arr1.isBindCellphone == 1 && arr1.isBindCard == 1) {
							//完成状态
							commit('upDatanoviceTaskStatus', 2);
						} else {
							commit('upDatanoviceTaskStatus', 1);
						}
						// if (arr1.includes(0)) {
						// 	commit("upDatanoviceTaskStatus", 1);
						// } else {
						// 	commit("upDatanoviceTaskStatus", 2);
						// }
					}
				});
		},
	},
	getters: {
		userInfo: state => {
			return state.userInfo;
		},
		userBinding: state => {
			return state.userBinding;
		},
		equityIncome: state => {
			return state.equityIncome;
		},
		hasLogged: state => {
			return state.hasLogged;
		},
		loadingCtrl: state => {
			return state.sysLoadingFlag;
		},
		isTestAccount: state => {
			return state.isTestAccount;
		},
		userBalance: state => {
			return state.userBalance;
		},
		initUserData: state => {
			return state.initUserData;
		},
		UserFunc: state => {
			return state.UserFunc;
		},
		noviceTaskStatus: state => {
			return state.noviceTaskStatus;
		},
		announceRecommendGm: state => {
			return state.announceRecommendGm;
		},
	},
};
